import { AppCompany, AppImage } from 'types';

import { IExchangeSettings, IPaymentMethodsSettings } from 'modules/eecs-go';
import { IGrexAccounts } from 'modules/grex';
import { IHknrAccount } from 'modules/hknr';
import { INecsAccount } from 'modules/necs';

export enum EUserRoles {
  ADMIN = 'admin',
  USER = 'user',
  COMPANY_ADMIN = 'company admin',
}

export enum ETwoFaMethod {
  APP = 'google',
  EMAIL = 'email',
}

export enum ETwoFaStepState {
  SETUP = 'setup',
  QR_CODE = 'qr_code',
  REMOVE = 'remove',
  CONFIRM_CODE = 'confirm_code',
}

export enum ETwoFaStepConfirmCodeState {
  ENABLE_APP = 'enable_app',
  REMOVE_APP = 'remove_app',
  CONFIRM_EMAIL = 'confirm_email',
}

export interface IUserRole {
  id: number;
  name: EUserRoles;
}
export interface IUserCompany extends AppCompany {
  id: number;
  is_complete_eecs_flow: boolean;
  necs_account?: INecsAccount | null;
  hknr_account?: IHknrAccount | null;
  grex_accounts: IGrexAccounts;
  email: string;
  payment_settings: IPaymentMethodsSettings;
}

export interface IUser {
  id: number;
  fullName: string;
  first_name: string;
  last_name: string;
  phone_number: string;
  username: string;
  avatar: AppImage;
  id_document: AppImage;
  login: string;
  email: string;
  company: IUserCompany;
  uuid: string;
  roles: IUserRole[];
  hasAdminAccess?: boolean;
  hasCompanyAdminAccess?: boolean;
  two_factor_method: ETwoFaMethod;
  exchange_settings: IExchangeSettings;
  admin_companies: AppCompany[];
  country_code: string;
  region_code: string;
  model_type: string;
  api_token_created_at: string | null;
}

export interface LoginPayload {
  login: string;
  password: string;
}

export interface LoginResponse {
  two_fa_method: ETwoFaMethod | null;
}

export interface SignupPayload {
  login: string;
  first_name: string;
  last_name: string;
  username: string;
  email: string;
  password: string;
  country_code: string | null;
  region_code: string | null;
  invitation_code: string;
  id_document?: File | null;
}

export interface VerifyOtpPayload {
  code: string;
}

export interface ResetTwoFaPayload {
  user_id: number;
}

export interface EnableTwoFaAppResponse {
  qr_code: string;
  secret: string;
}

export interface ResetPasswordPayload {
  email: string;
}

export interface SetNewPasswordPayload {
  token: string;
  password: string;
  email: string;
}

export interface ChangePasswordPayload {
  current_password: string;
  new_password: string;
  new_password_confirmation: string;
}
